import { render, staticRenderFns } from "./accessLogin.vue?vue&type=template&id=2f1a2c21&"
import script from "./accessLogin.vue?vue&type=script&lang=js&"
export * from "./accessLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports